module.exports = __webpack_public_path__ + "img/CersoofBlueTears.dd2bcad4.png";